import { createTheme } from '@mui/material';
import { breakpointsValues } from '@themes/breakpoints';
import { components } from '@themes/components';
import { lightColorPalette } from '@themes/light/palette.light';
import { typography } from '@themes/typography';

export const themeLight = createTheme({
  breakpoints: {
    values: breakpointsValues,
  },
  palette: {
    ...lightColorPalette,
  },
  typography: {
    ...typography,
  },
  components,
});
